import { css } from '@emotion/react';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const popoverContainerStyles = css`
  display: flex;
  align-items: center;
  padding: var(${SpacingToken.Spacing2});
  border-radius: var(${RadiusToken.Radius3});

  &:hover {
    background-color: var(${DesignToken.SurfaceSecondaryDefault});
    cursor: pointer;
  }
`;

export const popoverEmailStyles = css`
  display: none;

  ${MEDIA_MIN_SM} {
    display: flex;
    margin: 0 var(${SpacingToken.Spacing1}) 0 var(${SpacingToken.Spacing2});
  }
`;
